// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sso-btn {
  border-radius: 8px;
  border: 1px solid #1E38A9;
  display: flex;
  width: 190px;
  height: 52px;
  padding: 4px 0px 4px 16px;
  align-items: center;
  gap: 8px;
  background: transparent;
  margin: 25px auto 0 auto;
  cursor: pointer;
}
.sso-btn span {
  border-left: 1px solid #1E38A9;
  padding: 3px 0 3px 0px;
  color: #1E38A9;
  text-align: center;
  font-family: Arial;
  font-size: 14px;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: -0.25px;
  width: 142px;
}
.sso-btn:hover {
  color: #fff;
  background: #1E38A9;
}
.sso-btn:hover span {
  color: #fff;
  border-color: #fff;
}

.gc-auth-icons-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  position: absolute;
  bottom: calc(0% + 70px);
  left: 50%;
  transform: translateX(-75%);
  width: 100%;
}
.gc-auth-icons-row .auth-icon-intuition {
  filter: invert(1) hue-rotate(180deg);
}

.auth-icon-intuition {
  width: 80px;
  object-fit: contain;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
